var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-button",
        {
          directives: [
            {
              name: "permission",
              rawName: "v-permission",
              value: "contacts.create",
              expression: "'contacts.create'"
            },
            {
              name: "ripple",
              rawName: "v-ripple.400",
              value: "rgba(255, 255, 255, 0.15)",
              expression: "'rgba(255, 255, 255, 0.15)'",
              modifiers: { "400": true }
            }
          ],
          attrs: { variant: "primary" },
          on: { click: _vm.addNew }
        },
        [
          _c("feather-icon", {
            staticClass: "mr-50",
            attrs: { icon: "PlusIcon" }
          }),
          _c("span", { staticClass: "align-middle" }, [
            _vm._v(_vm._s(_vm.$t("AddNew")))
          ])
        ],
        1
      ),
      _c("Grid", {
        attrs: { service: _vm.service, route_name: "contacts" },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(actions) {
              return [
                !_vm.hide_edit
                  ? _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "contacts.edit",
                          expression: "`contacts.edit`"
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-warning",
                      attrs: { icon: "EditIcon" },
                      on: {
                        click: function($event) {
                          return actions.methods.edit(
                            actions.data[actions.indextr].id
                          )
                        }
                      }
                    })
                  : _vm._e(),
                !_vm.hide_delete
                  ? _c("feather-icon", {
                      directives: [
                        {
                          name: "permission",
                          rawName: "v-permission",
                          value: "contacts.delete",
                          expression: "`contacts.delete`"
                        }
                      ],
                      staticClass:
                        "h-5 w-5 mb-1 mr-1 stroke-current text-danger",
                      attrs: { icon: "Trash2Icon" },
                      on: {
                        click: function($event) {
                          return actions.methods.destroy(
                            actions.data[actions.indextr]
                          )
                        }
                      }
                    })
                  : _vm._e()
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }